import { render, staticRenderFns } from "./loginModule.vue?vue&type=template&id=ed4d3158&scoped=true&"
import script from "./loginModule.vue?vue&type=script&lang=js&"
export * from "./loginModule.vue?vue&type=script&lang=js&"
import style0 from "./loginModule.vue?vue&type=style&index=0&id=ed4d3158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4d3158",
  null
  
)

export default component.exports